"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import {
  CODE_URL_PARAM,
  DEFAULT_CURRENCY_CODE,
  useCurrencyStore,
} from "@/store/index";
import { getCurrencyLabel } from "@/lib/util/utils";

export const CurrencyUrlSync = () => {
  const { currencyCode } = useCurrencyStore();
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const handler = setTimeout(() => {
      const params = new URLSearchParams(searchParams.toString());
      const newCurrencyLabel = getCurrencyLabel(
        currencyCode ?? DEFAULT_CURRENCY_CODE
      );

      if (params.get(CODE_URL_PARAM) !== newCurrencyLabel) {
        params.set(CODE_URL_PARAM, newCurrencyLabel);
        router.replace(`${pathname}?${params.toString()}`, { scroll: false });
      }
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [currencyCode, pathname, searchParams, router]);

  return null;
};
